import React from 'react';
import {Route} from 'react-router';
import mobileSwitch from './containers/MobileSwitch/MobileSwitch';
import Reservation from './containers/Reservation/Reservation';
import ModifyReservationMobile from './containers/ModifyReservationMobile/ModifyReservationMobile';
import CancelReservation from './containers/CancelReservation/CancelReservation';
import CancelReservationMobile from './containers/CancelReservationMobile/CancelReservationMobile';
import AddToCalendarDesktop from './containers/AddToCalendarDesktop/AddToCalendarDesktop';
import AddToCalendarMobile from './containers/AddToCalendarMobile/AddToCalendarMobile';

export default function () {
  return (
    <Route path="/reservation/:base64Params" component={mobileSwitch(Reservation, ModifyReservationMobile)}>
      <Route path="cancelReservation" component={mobileSwitch(CancelReservation, CancelReservationMobile)}/>
      <Route path="addToCalendar" component={mobileSwitch(AddToCalendarDesktop, AddToCalendarMobile)}/>
    </Route>
  );
}



// WEBPACK FOOTER //
// ./routes.js